import React, { useState, useEffect } from 'react';
import { resetPassword } from '../../services/forgotPasswordService.ts';
import LogoIconSrc from './../../assets/icons/logo/pixle-pro-logo.svg';
import './resetPassword.css';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { authErrorMessage, authMessage } from '../../i18n/authMessages';
import { detectLanguage } from '../../i18n/language';

const ResetPasswordPage: React.FC = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await resetPassword({ token, password });
      const language = detectLanguage();
      if (response.message) {
        toast.success(authMessage('reset.success', language));
        toast.success(authMessage('reset.redirecting', language));
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error: any) {
      toast.error(authErrorMessage(error, 'reset.failed'));
    }
    setLoading(false);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlToken = searchParams.get('token');

    if (urlToken) {
      setToken(urlToken);
    }
  }, [location]);

  return (
    <div className="resetPassword-container">
      <div className="resetPassword-right">
        <img src={LogoIconSrc} alt="Logo Icon" />
        <h2 className="resetPassword-title">Change Password</h2>

        <form className="resetPassword-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New Password *</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Type your password here"
              required
            />
          </div>

          <div className="resetPassword-controls">
            <button
              type="submit"
              className="resetPassword-button"
              disabled={loading}
            >
              {loading ? 'Updating Password...' : 'Update Password'}
            </button>
            <p className="register-text">
              New to Pixle? <a href="/signup">Start your free trial</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
